export const font = {
    regular: "'Roboto', 'Helvetica Neue', Arial, Helvetica, sans-serif",
    mono: "'Roboto Mono', 'Lucida Console', Monaco, monospace",
};

export const FONT_SIZES = {
    extraSmall: 'extraSmall',
    small: 'small',
    mediumSmall: 'mediumSmall',
    medium: 'medium',
    mediumLarge: 'mediumLarge',
    large: 'large',
    extraLarge: 'extraLarge',
};

export const fontSize = {
    [FONT_SIZES.extraSmall]: '10px',
    [FONT_SIZES.small]: '11px',
    [FONT_SIZES.mediumSmall]: '12px',
    [FONT_SIZES.medium]: '13px',
    [FONT_SIZES.mediumLarge]: '16px',
    [FONT_SIZES.large]: '22px',
    [FONT_SIZES.extraLarge]: '26px',
};
